import styled from "@emotion/styled";

export const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: #282c34;
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    flex-direction: row; /* Ensure the hamburger menu stays on the same row */
    position: relative; /* Needed for dropdown positioning */
  }
`;

export const Logo = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
`;

export const NavBar = styled.nav`
  display: flex;
  gap: 1.5rem;

  @media (max-width: 768px) {
    display: none; /* Hide the navigation bar by default on small screens */
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0; /* Ensure no overflow on the right side */
    padding: 1rem;
    background-color: #282c34;
    box-sizing: border-box; /* Include padding in the element’s width/height calculation */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1000;
  }

  &.open {
    display: flex; /* Show the nav bar when menu is open */
  }
`;

export const NavButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }

  &:focus {
    outline: none;
    background-color: rgba(255, 255, 255, 0.3);
  }
`;

export const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;

  @media (max-width: 768px) {
    display: block; /* Show the menu button on small screens */
    margin-left: auto; /* Push the menu button to the right */
  }
`;
